export const FORM_LOGIN = 0;
export const FORM_FORGOT_PASSWORD = 1;
export const FORM_SET_PASSWORD = 2;
export const FORM_OTP = 3;
export const FORM_VERIFY_IDENTITY = 4;
export const RESET_PASSWORD_CONFIRM = 5;
export const PASSWORD_SET_CONFIRM = 6;
export const SETUP_PIN = 7;
export const VALIDATE_PIN = 8;
export const RESET_PIN = 9;
